import React from "react";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';



export default function ContactPage() {

  return (
     <div>
      <div className="text-center my-5">
        <h1 className="mb-4 contactStyle">Contact Me</h1>
      </div>
      <Form
        action="https://submit-form.com/JSeCtNjqZ"
        method="POST"
        className="mt-5 contact-form"
      >
        <Row className="mb-3">
          <Col>
            <Form.Group controlId="formBasicName">
              <Form.Label>Name:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                name="name"
                required
              />
            </Form.Group>
          </Col>

          <Col>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email:</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                required
              />
            </Form.Group>
          </Col>

          <Col>
            <Form.Group controlId="formBasicPhone">
              <Form.Label>Phone:</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter phone number"
                name="phone"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="formSubject">
              <Form.Label>Subject:</Form.Label>
              <Form.Select name="subject" required defaultValue="" aria-label="Select a subject">
                <option value="" disabled>Select a subject</option>
                <option value="freelance">Freelance / Contract Work</option>
                <option value="job-opportunity">Job Opportunity</option>
                <option value="internship">Internship</option>
                <option value="general-inquiry">General Inquiry</option>
                <option value="feedback">Feedback / Suggestions</option>
                <option value="other">Other</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="formMessage">
              <Form.Label>Message:</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter your message"
                name="message"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form>
    </div>
  );
}